import React, { useEffect, useState } from "react"
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
} from "reactstrap"

import downArrowIcon from "../../../assets/images/icons/down-arrow-color.svg"
import NoData from "../../../assets/images/noData.svg"
import SearchIco from "../../../assets/images/icons/search.svg"
import Sliders from "../../../assets/images/icons/sliders.svg"
import { useLazyGetDashboardReferralTrackingQuery } from "store/api/wealthpartnerapi/wealthReport"
import { formatAmount, getInvestorsStatus } from "helpers/common"

const allStatuses = ["Registration", "Agreement", "Offer", "Invested"]
const defaultFilters = {
  statuses: allStatuses,
  period: "This Year",
}
const periods = [
  "This Year",
  "This Half Year",
  "This Quarter",
  "This Month",
  "This Week",
]

const ReferralTracking = () => {
  const [statuses, setStatuses] = useState([])
  const [selected, setSelected] = useState([...allStatuses])
  const [search, setSearch] = useState("")
  const [companyStatusOpen, setCompanyStatusOpen] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const toggle = () => setDropdownOpen((prevState) => !prevState)
  const [filters, setFilters] = useState(defaultFilters)
  const [data, setData] = useState([])
  const [wealthPartnerOpen, setwealthPartnerOpen] = useState(false)
  const [getResults, { isFetching }] =
    useLazyGetDashboardReferralTrackingQuery()

  const getList = async () => {
    try {
      if (selected.length <= 0) {
        setData([])
        return
      }
      const { data } = await getResults({ ...filters }).unwrap()
      setData(data)
    } catch (e) {}
  }

  useEffect(() => {
    getList()
  }, [filters])

  const applyFilters = () => {
    setFilters({ ...filters, statuses })
    setCompanyStatusOpen(false)
  }

  const handleChange = (item) => {
    setSelected((prevSelected) =>
      prevSelected.includes(item)
        ? prevSelected.filter((i) => i !== item)
        : [...prevSelected, item]
    )
  }

  useEffect(() => {
    const filtered = search
      ? allStatuses.filter((item) =>
          item.toLowerCase().includes(search.toLocaleLowerCase())
        )
      : [...allStatuses]
    setStatuses(filtered)
  }, [search])

  return (
    <React.Fragment>
      <div className="company-table-wrapper">
        <div className="filter-section">
          <h4>Referral Tracking</h4>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              justifyContent: "flex-end",
            }}
          >
            <div className="filter-dropdown-section">
              <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                <DropdownToggle caret size="lg">
                  {filters.period} <img src={downArrowIcon} alt="" />
                </DropdownToggle>
                <DropdownMenu style={{ minWidth: "auto" }}>
                  {periods.map((item, index) => (
                    <DropdownItem
                      key={`periods_${index}`}
                      onClick={() => setFilters({ ...filters, period: item })}
                    >
                      {item}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </Dropdown>
            </div>
            {/* <div className="filter">
              <Dropdown
                isOpen={companyStatusOpen}
                toggle={() => setCompanyStatusOpen(!companyStatusOpen)}
                direction="end"
              >
                <DropdownToggle size="lg">
                  <img src={Sliders} alt="" />
                </DropdownToggle>
                <DropdownMenu>
                  <div className="dropdown-item-section">
                    <div className="input-wrapper">
                      <img src={SearchIco} alt="" />
                      <Input
                        name="Search"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search"
                        type="text"
                      />
                    </div>
                    <div className="filter-reset">
                      <p onClick={() => setSelected([...statuses])}>
                        Select All{" "}
                      </p>
                      <p onClick={() => setSelected([])}>Clear All </p>
                    </div>
                    <div className="checkbox-section">
                      {statuses.map((item, index) => (
                        <FormGroup check key={`statuses_${index}`}>
                          <Input
                            type="checkbox"
                            id={item}
                            checked={selected.includes(item)}
                            value={item}
                            onChange={() => handleChange(item)}
                          />
                          <Label htmlFor={item} check>
                            {item}
                          </Label>
                        </FormGroup>
                      ))}
                    </div>
                    <div className="bottom-section">
                      <p
                        className="clos"
                        onClick={() => setCompanyStatusOpen(!companyStatusOpen)}
                      >
                        Close
                      </p>
                      <p className="done" onClick={applyFilters}>
                        Done
                      </p>
                    </div>
                  </div>
                </DropdownMenu>
              </Dropdown>
            </div> */}
          </div>
        </div>
        <div className="company-table-details">
          <Table responsive>
            <thead>
              <tr>
                <th
                  style={{
                    backgroundColor: "#F0A735",
                  }}
                >
                  Name
                </th>
                <th className="name text-center">Status</th>
                <th className="action text-center">Commission</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item, index) => (
                <tr key={`top_performer_${index}`}>
                  <td>{item.name}</td>
                  <td className="text-center">
                    <div className="code-status">
                      {getInvestorsStatus(
                        item.commission > 0 ? "INVESTED" : item.status
                      )}
                    </div>
                  </td>
                  <td>
                    <div className="text-center">
                      {item.commission > 0
                        ? `₹ ${formatAmount(item.commission)}`
                        : "-"}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          {!isFetching && data.length <= 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                minHeight: "250px",
              }}
            >
              <img
                src={NoData}
                style={{
                  maxWidth: "160px",
                }}
                alt="Record not found"
              />
              <h4
                style={{
                  color: "#000000",
                  fontSize: "16px",
                  fontWeight: "600",
                  marginTop: "15px",
                  marginBottom: "5px",
                  textAlign: "center",
                }}
              >
                {selected.length <= 0
                  ? "Please select at least 1 filter"
                  : "No Records Found"}
              </h4>
            </div>
          )}
        </div>
      </div>
    </React.Fragment>
  )
}

export default ReferralTracking
